export const TEST_ID = 'onboardingStepCount';

export const FIRST_NAME = 'firstName';

export const LAST_NAME = 'lastName';

export const PHONE = 'phone';
